import { render, staticRenderFns } from "./nuevo_monitoreo.vue?vue&type=template&id=483d5aed&"
import script from "./nuevo_monitoreo.vue?vue&type=script&lang=js&"
export * from "./nuevo_monitoreo.vue?vue&type=script&lang=js&"
import style0 from "./nuevo_monitoreo.vue?vue&type=style&index=0&id=483d5aed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports